import { ref, computed } from '@vue/composition-api';
import { intersection, find, reject } from 'lodash';
import Fuse from 'fuse.js';

const add = (attribute, value) => {
    const existing = find(state.value, ['attribute', attribute]);

    if (existing) state.value = reject(state.value, ['attribute', attribute]);

    if (value) state.value.push({ attribute, value });
};

const filter = (dataset, attr) => {
    const fuse = new Fuse(dataset, {
        keys: attr.attribute,
        ignoreLocation: true,
        includeScore: true,
        includeMatches: true
    });

    const results = fuse.search(attr.value);

    // eslint-disable-next-line no-console
    // console.log(results);

    return results.map((r) => r.item);
};

export const state = ref([]);

export const execute = (dataset, filters) => {
    return filters.length
        ? intersection(...filters.map((item) => filter(dataset, item)))
        : dataset;
};

export default (attribute) => {
    const refine = (value) => add(attribute, value);
    const active = computed(() => {
        const matched = state.value.find((s) => s.attribute === attribute);
        return matched ? matched.value : [];
    });
    return { refine, active };
};
